import { RefObject } from 'react';
import { DropTargetMonitor } from 'react-dnd';

export const getMousePosition = (ref: RefObject<HTMLDivElement>, monitor: DropTargetMonitor) => {
    if (!ref.current) {
        return {};
    }
    const hoverBoundingRect = ref.current?.getBoundingClientRect();
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = clientOffset!.y - hoverBoundingRect.top;
    return {
        isInTopHalf: hoverClientY < hoverMiddleY,
        isInBottomHalf: hoverClientY > hoverMiddleY,
    };
};
